// extracted by mini-css-extract-plugin
export default {"svg":"EventList_svg__PulJm","active":"EventList_active__W454c"};